
const filterNameInvalid = 'Filter name must be a valid string'
const filterRemovedFiltersInvalid = 'Removed filters must be a valid string'

// eslint-disable-next-line complexity
function filterRemovedClicked (filterName, removedFilters = '', fromAppliedFilters = false) {
  if (!filterName || (filterName && typeof filterName !== 'string')) throw Error(filterNameInvalid)
  if (!removedFilters || (removedFilters && typeof removedFilters !== 'string')) throw Error(filterRemovedFiltersInvalid)

  const subject = fromAppliedFilters ? 'APPLIED FILTERS' : 'NO RESULTS PAGE'
  const attributes = {
    filter_name: filterName,
    removed_filters: removedFilters,
    subject,
  }

  return {
    event: 'filterRemovedClicked',
    attributes,
  }
}

export default filterRemovedClicked
